<template>

  <ControlloStorniRid />
 
</template>

<script>
import ControlloStorniRid from '../components/pratiche/ControlloStorniRid.vue'

export default {
  pageName: '',
  components: {
    ControlloStorniRid

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
